const BADGE_MEMBER_STATUSES = {
    LOCKED: 'Locked',
};

const BADGE_VIEW_TYPES = {
    ACHIEVED: 'Achieved',
    IN_PROGRESS: 'In Progress',
};

export const formatBadgeImageUrl = (imageURL, width, height) => {
    if (!imageURL) return undefined;

    const trimmedUrl = imageURL.trim();

    if (!width || !height) {
        return trimmedUrl;
    }

    return `${trimmedUrl}?width=${width}&height=${height}`;
};

export const getBadgeImage = (badge) => {
    return getBadgeImageByViewType(badge, badge?.memberBadgeStatus);
};

export const getAchievedBadgeImage = (badge) => {
    return getBadgeImageByViewType(badge, BADGE_VIEW_TYPES.ACHIEVED);
};

export const getInProgressBadgeImage = (badge) => {
    return getBadgeImageByViewType(badge, BADGE_VIEW_TYPES.IN_PROGRESS);
};

export const getLockedBadgeImage = (badge) => {
    return getBadgeImageByViewType(badge, BADGE_MEMBER_STATUSES.LOCKED);
};

const getBadgeImageByViewType = (badge, viewType) => {
    return badge?.badgeImage?.find((img) => img?.viewType === viewType);
};

export const isBadgeLocked = (badge) => {
    return badge?.memberBadgeStatus === BADGE_MEMBER_STATUSES.LOCKED;
};

export const isBadgeAchieved = (badge) => {
    return badge?.memberBadgeStatus === BADGE_VIEW_TYPES.ACHIEVED;
};
